export default __webpack_public_path__ + "static/acronis-041285d77327f7011c92e188b7f3a4b9.jpg";